import type {
  CampaignStatus,
  ContactLabel,
  ContactStatus,
  TargetResult,
  TargetState,
} from '@/shared/api/types'

export const CONTACT_STATUS = {
  new: { label: 'Новый', tone: 'neutral' },
  no_answer: { label: 'Не дозвонились', tone: 'warning' },
  talked: { label: 'Поговорили', tone: 'success' },
  do_not_call: { label: 'Не звонить', tone: 'danger' },
} as const satisfies Record<ContactStatus, { label: string; tone: string }>

export const CONTACT_LABELS: { value: ContactLabel; label: string; tone: string }[] = [
  { value: '', label: 'Без метки', tone: 'neutral' },
  { value: 'hot', label: 'Горячий', tone: 'danger' },
  { value: 'interested', label: 'Интересуется', tone: 'success' },
  { value: 'thinking', label: 'Думает / перезвонить', tone: 'warning' },
  { value: 'cold', label: 'Холодный', tone: 'info' },
  { value: 'negative', label: 'Негатив', tone: 'danger' },
  { value: 'do_not_call', label: 'Не звонить', tone: 'danger' },
]

export function contactLabel(value: ContactLabel): string {
  return CONTACT_LABELS.find((item) => item.value === value)?.label ?? 'Без метки'
}

export const CAMPAIGN_STATUS = {
  running: { label: 'Идёт', tone: 'success' },
  paused: { label: 'На паузе', tone: 'warning' },
  stopped: { label: 'Остановлен', tone: 'danger' },
  done: { label: 'Завершён', tone: 'neutral' },
} as const satisfies Record<CampaignStatus, { label: string; tone: string }>

export const TARGET_STATE = {
  queued: 'Ждёт звонка',
  dialing: 'Звоним сейчас',
  done: 'Завершён',
  skipped: 'Пропущен',
} as const satisfies Record<TargetState, string>

export const TARGET_RESULT = {
  '': '—',
  talked: 'Поговорили',
  no_answer: 'Не ответили',
  busy: 'Занято',
  failed: 'Ошибка',
  blocked: 'Звонок запрещён',
  cancelled: 'Отменён',
} as const satisfies Record<TargetResult, string>
